<template>
    <div class="slide-load">
        <ul class="infolistWrap" v-if="infosSlide.length>0">
            <li v-for="info in infosSlide">
                <template v-if="info.flag">
                    <div class="hotRecom">
                        <p class="hotRecom-title">热门推荐</p>
                        <ul>
                            <li v-for="item in info.keyWords" class="fl">
                                <a v-link="{ name: 'search', params: { keyword: item.name }}" v-touch:tap="onNavClick(item.name)"><span
                                        class="hotRecom-word">{{item.name}}</span></a>
                            </li>
                        </ul>
                    </div>
                </template>
                <template v-else>
                    <a @click="goToDetailorder(info)" class="info-jumlUrl">
                        <div :style="{'background-image' : 'url(' + infoImageHandle(info.infoImage || info.infoPics || info.pics) + ')'}"
                             class="fl info-img"></div>
                        <dl class="fl info-des">
                            <dt class="info-title">{{info.title || info.infoTitle}}{{info.desc }}</dt>
                            <dd class="info-userWrap">
                                <img :src="info.headImg || info.userPic | headImgHandle" class="info-headImg">
                                <span class="info-nickname">{{info.nickName || info.userNickName}}</span>
                            </dd>
                            <dd class="info-addAndPri">
                                <span class="info-newPrice">￥<strong>{{info.price || info.nowPrice}}</strong></span>
                                <span class="info-oldPrice"
                                      v-if="info | originalPriceHandle ">原价{{info.originalPrice || info.oriPrice}}</span>
                                <span v-if="!orderd" class="fr info-address">{{info.cityName}} | {{info.businessName || info.areaName}}</span>
                            </dd>
                        </dl>
                    </a>
                </template>
            </li>
        </ul>
        <div class="loading" v-show="gettingData && !over">正在加载数据，请稍等</div>
        <div class="loading" v-show="over">已经到底了</div>
        <div v-if="nodata=='nodata' " class="nodata">
            <img src="./nodata.png">
            <p>没有找到相关宝贝</p>
        </div>
    </div>
</template>
<style lang="less">
    @import "SlideLoad.less";
</style>
<script>
    var adjustPic = require("../../libs/adjustPic.js");
    var isScrollBottom = require("../../libs/isScrollBottom.js");
    var leStatic = require('../../libs/leStatic');
    var Cookies = require("../../libs/cookie");
    module.exports = {
        props: ['slidemessage','orderd'],
        created: function () {
            console.log('slide-load:created');
            this.onScroll = function () {
                if (isScrollBottom.init() && !this.gettingData && this.nodata !== 'nodata') {
                    console.log('slideload:scroll');
                    this.gettingData = true;
                    this.modifyInfos(this.slidemessage, "addData");
                }
            }.bind(this);
            this.modifyInfos(this.slidemessage, "newData");
        },
        data: function () {
            return {
                bannerUrl: "",
                bannerSrc: "",
                infosSlide: [],
                pagenum: 2,
                nodata: null,
                gettingData: false,
                over: false,
                scrollTop : 0
            }
        },
        watch: {
            "slidemessage": function (param) {
                this.nodata = null;
                this.over = false;
                console.debug('slideload:slidemessage change');
                this.modifyInfos(param, "newData");
            }
        },
        activate : function (next) {
            console.log('slide-load:activate');
            next();
        },
        filters: {
            bannerFilter: function (imgSrc) {
                if (imgSrc) {
                    return true;
                } else {
                    return false;
                }
            },
            headImgHandle: function (headImg) {
                var defaultsrc = "https://img.58cdn.com.cn/zhuanzhuanftp/pic_default_headimg@2x.png";
                if (headImg == "") {
                    return defaultsrc;
                }
                if (typeof(headImg) == "string") {
                    return adjustPic.init(headImg, 100, 100);
                } else {
                    return defaultsrc;
                }
            },
            originalPriceHandle: function (info) {
                if ((info.hasOwnProperty("originalPrice") || info.hasOwnProperty("oriPrice")) && info.originalPrice != "" && info.originalPrice != 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            goToDetailorder: function(info) {
              var product_id = info.strInfoId || info.infoId,
                  pageType = this.orderd ? 'order' : 'detail',
                  paramId = this.orderd ? { order_id: info.orderId } : { product_id: product_id },
                  wubaParamid = this.orderd ? info.orderId : product_id ;
              if(Cookies.get('58ua') == "58app"){
                leStatic("zzdetail_wxclick");
                window.location.href = 'https://m.zhuanzhuan.58.com/Mzhuanzhuan/zz58app/' + pageType + '/' + wubaParamid;
              }else {
                this.$router.go({
                  name : pageType,
                  params : paramId
                });
              }
            },
            infoImageHandle: function (infoImage) {
                var src = "https://img.58cdn.com.cn/zhuanzhuanftp/pic_default_headimg@2x.png";
                if (typeof(infoImage) == "string" && infoImage) {
                    if(infoImage.indexOf('|')>-1){
                        var _url = infoImage.split('|')[0];
                        src = adjustPic.init(_url, 210, 210);
                    }else{
                        src = adjustPic.init(infoImage, 210, 210);
                    }
                }
                return src;
            },
            hotWordHandle: function (param) {
                //热门推荐跳转搜索结果页
                var url = window.location.href.split("#!")[0];
                var _href = url + '#!/search/' + param.name;
                this.$router.go(_href);
            },
            onNavClick: function (item) {
                //新增热门加载页面埋点
                leStatic("MONITOR-HOTCLICK");
            },
            modifyInfos: function (paramData, infotype) {
                //列表内容加载
                var url = paramData.url;
                var jsonpdata = paramData.params;
                //addData代表滑动加载的信息，newData代表刚进入，加载第一页的信息，并重置滑动加载的页码为2
                if (infotype == "addData") {
                    for(var k in jsonpdata){
                        jsonpdata[k] = (k === "pageNumber" || k === "pageNum" || k === "pagenum") ? this.pagenum : jsonpdata[k];
                    }
                    this.pagenum = this.pagenum + 1;
                } else {
                    this.pagenum = 2;
                }
                this.$http.jsonp(url, jsonpdata).then(function (response) {
                    this.reqFlag = true;
                    if (response.data.respCode == "0") {
                        if (!!response.data.respData) {
                            var dataArr = !!response.data.respData.infos?response.data.respData.infos:response.data.respData;
                            var len = dataArr.length;
                            var pageData = [];
                            var num = 0;
                            var hotRecom = {
                                flag: false,
                                keyWords: []
                            };
//                        返回数据有值，至少有一个
                            if (len > 0) {
                                if (infotype == "newData") {
                                    //第一页数据判断第一项是否为banner数据
                                    this.bannerSrc = dataArr[0].hasOwnProperty("imageUrl") ? dataArr[0].imageUrl : "";
                                    this.bannerUrl = dataArr[0].hasOwnProperty("goUrl") ? dataArr[0].goUrl : "";
                                    num = this.bannerSrc == "" ? 0 : 1;
                                    document.body.scrollTop = 0;
                                }
                                for (var i = num; i < len - 1; i++) {
                                    pageData.push(dataArr[i]);
                                }
                                if (this.pagenum - 1 == 2 || this.pagenum - 1 == 4) {
                                    if (dataArr[len - 1].hasOwnProperty("hotSet")) {
                                        hotRecom.flag = true;
                                        hotRecom.keyWords = dataArr[len - 1].hotSet;
                                        pageData.push(hotRecom);
                                    }
                                } else {
                                    pageData.push(dataArr[len - 1]);
                                }
                                if (this.pagenum - 1 == 3 || this.pagenum - 1 == 5) {
                                   //热门展示列表，浏览数量埋点
                                   leStatic('MONITOR-HOT');
                                }
                                this.infosSlide = infotype == "newData" ? pageData : this.infosSlide.concat(pageData);
                                if (len < 10) {
                                    this.gettingData = true;
                                    this.over = true;
                                } else {
                                    this.gettingData = false;
                                }
                            } else {
                                this.gettingData = true;
                                if (infotype == "newData") {
                                    this.nodata = 'nodata';
                                    this.gettingData = false;
                                    this.infosSlide = [];
                                } else {
                                    this.over = true;
                                }
                            }
                        } else {
                            this.gettingData = true;
                            if (infotype == "newData") {
                                this.nodata = 'nodata';
                                this.infosSlide = [];
                            } else {
                                this.over = true;
                            }
                        }
                    }
                }, function (response) {
                    // error callback
                    console.log("fail" + response.status);
                });
            }
        },
        events : {
            startScroll : function () {
                setTimeout(function () {
                    window.scrollTo(0, this.scrollTop);
                    console.log('start scroll',this.scrollTop);
                    document.addEventListener('scroll', this.onScroll);
                }.bind(this),50);
            },
            cancelScroll : function () {
                this.scrollTop = document.body.scrollTop;
                console.log('cancel scroll',this.scrollTop);
                document.removeEventListener('scroll', this.onScroll);
            },
            refresh:function(params){
                console.log('refresh');
                //this.slidemessage.params.keyword = this.$route.params.keyword;
                this.modifyInfos(this.slidemessage, "newData");
            }

        }
    }
</script>



/** WEBPACK FOOTER **
 ** SlideLoad.vue?78ff8073
 **/